/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Popover } from "reactstrap";

const DismissablePopover = (props) => {
  const { isOpen, toggle, children, zIndex } = props;

  return (
    <>
      <Popover {...props}>
        {children}
      </Popover>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: isOpen ? "#2234" : "#0000",
          transition: "background-color 150ms ease-in",
          width: isOpen ? "" : "0",
          height: isOpen ? "" : "0",
          zIndex: zIndex ?? 99
        }}
        onClick={toggle}
      />
    </>
  );
};

export default DismissablePopover;
